import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axios';
import { getRole } from '../../utils/role';

const initialState = {
  profile: {}, 
  status: 'idle',
  error: null,
};

// --- FETCH PROFILE ---
export const fetchProfile = createAsyncThunk(
  'profile/fetchProfile',
  async (_, { rejectWithValue }) => {
    try {
      const role = getRole();
      let url = '';

      if (role === 'FIELD_OFFICER') {
        url = '/field-officer/profile';
      } else if (role === 'FARMER') {
        url = '/user/details';
      } else {
        return {};
      }

      const { data } = await axiosInstance.get(url);
      return data.profile || data;

    } catch (err) {
      return rejectWithValue(err.response?.data?.msg || 'Failed to fetch profile');
    }
  }
);

// --- UPDATE PROFILE ---
export const updateProfile = createAsyncThunk(
  'profile/updateProfile',
  async (formData, { rejectWithValue, getState }) => {
    try {
      const role = getRole();
      
      if (role === 'FIELD_OFFICER') {
        const { data } = await axiosInstance.put('/field-officer/profile', formData);
        return data.updatedProfile;
      } 
      
      if (role === 'FARMER') {
        const userId = formData.user_id; 
        const { data } = await axiosInstance.put(`/user/details/${userId}`, { data: formData });
        return data;
      }

    } catch (err) {
      return rejectWithValue(err.response?.data || 'Update Failed');
    }
  }
);

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchProfile.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchProfile.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.profile = action.payload || {};
      })
      .addCase(fetchProfile.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })

      // Update
      .addCase(updateProfile.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(updateProfile.fulfilled, (state, action) => {
        state.status = 'succeeded';
        // Merge updates
        state.profile = { ...state.profile, ...action.payload };
        alert('Profile Updated Successfully!');
      })
      .addCase(updateProfile.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
        alert('Failed to update profile');
      });
  },
});

export default profileSlice.reducer;